import {Ellipsis, SubTitle} from "@FRAMEWORK/ui/desktop/text";
import styled from "styled-components";

const ContentTitleWrap = styled.div`
	position: relative;
`;

const ContentTitle = styled(SubTitle)`
	margin: 60px 0 20px;
`;

const AditorCaution = styled.div`
	margin-top: 11px;
`;

const ButtonWrap = styled.div`
	position: absolute;
	bottom: -6px;
	right: 0;
	display: flex;
	justify-content: end;
`;

const List = styled.ul`
	margin-top: 10px;
	border-top: 1px solid var(--line-color);
`;

const ListItem = styled.li`
	border-bottom: 1px solid var(--line-color);
`;

const ListContent = styled.div<{isActive: boolean}>`
	display: flex;
	height: 70px;
	flex-flow: row nowrap;
	flex-grow: 1;
	flex-basis: 0;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;

	${props =>
		props.isActive &&
		`
        h5 {
            
			font-family: "PT-medium";
        }
    `}
`;

const ListTitle = styled.div`
	display: flex;
	height: 70px;
	align-items: center;
	h5 {
		padding-left: 20px;
		font-size: var(--medium-size);
		color: var(--emp-color);
		flex-grow: 2;
		${Ellipsis(2)}
	}
`;

const PriceWrap = styled.div`
	display: flex;
`;

const Price = styled.div`
	width: 270px;
	margin-left: 36px;
	color: var(--default-color);
	flex-shrink: 0;
	text-align: left;

	span {
		margin-right: 10px;
		color: var(--emp-color);
	}
`;

const MoreButton = styled.button<{isActive: boolean}>`
	padding: 0 20px;
	margin-top: -5px;
	background-color: transparent;

	&:after {
		display: block;
		width: 10px;
		height: 10px;
		border-top: 1px solid var(--emp-color);
		border-right: 1px solid var(--emp-color);
		font-size: 0px;
		transform: rotate(135deg);
		content: "";
	}

	${props =>
		props.isActive &&
		`
        margin-top: 9px;
        
        &:after {
            display: block;
            width: 10px;
            height: 10px;
            border-top: 1px solid var(--emp-color);
            border-right: 1px solid var(--emp-color);
            font-size: 0px;
            transform: rotate(-45deg);
            content: "";
        }
    `}
`;

const ListDetail = styled.div<{isActive: boolean; contentHeight: number}>`
	height: 0;
	transition: height 0.5s ease;
	opacity: 0;
	overflow: hidden;

	> div {
		display: flex;
		width: 100%;
		padding: 10px 0 30px;
	}
	${props =>
		props.isActive &&
		`
		opacity: 1;
		height: ${props.contentHeight}px;
	`}
`;

const Thumbnail = styled.div`
	width: 190px;
	height: 130px;
	margin-left: 20px;
	flex-basis: 190px;
	flex-shrink: 0;
	overflow: hidden;

	img {
		width: 100%;
		height: auto;
	}
`;

const TextBox = styled.div`
	width: 100%;
	margin: 0 18px 0 20px;

	p {
		line-height: 1.6;
	}

	dt {
		color: var(--emp-color);
	}
`;

const Summary = styled.div`
	display: flex;
	margin-top: 20px;
	align-items: center;
	gap: 28px;

	dl {
		display: flex;
		gap: 8px;
		line-height: 1;

		dt {
			position: relative;
			padding-left: 12px;

			&:before {
				position: absolute;
				top: 50%;
				left: 0;
				width: 3px;
				height: 3px;
				background-color: var(--bl-color);
				transform: translateY(-50%);
				content: "";
			}
		}
	}
`;

const Note = styled.div`
	margin-top: 20px;
	line-height: 1;

	span {
		position: relative;
		padding-left: 12px;
		color: var(--emp-color);

		&:before {
			position: absolute;
			top: 50%;
			left: 0;
			width: 3px;
			height: 3px;
			background-color: var(--bl-color);
			transform: translateY(-50%);
			content: "";
		}
	}

	div {
		padding: 10px 0 0 12px;
		line-height: 1.6;
	}
`;

const TextNone = styled.div`
	display: flex;
	height: 60px;
	border-bottom: 1px solid var(--line-color);
	align-items: center;
	justify-content: center;
`;

export {
	ContentTitleWrap,
	ContentTitle,
	AditorCaution,
	ButtonWrap,
	List,
	ListItem,
	ListContent,
	ListDetail,
	Price,
	MoreButton,
	Thumbnail,
	TextBox,
	Summary,
	Note,
	ListTitle,
	PriceWrap,
	TextNone,
};
